import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { DealType } from '__generated__/api';

export const getDealsFilterInput = (searchCriteria: SearchCriteriaModel): DealType[] | null => {
  if (searchCriteria.deals && searchCriteria.deals.length > 0) {
    return searchCriteria.deals
      .map(type => {
        const result = DealType[DealType[type]];

        return result ? result : null;
      })
      .filter(type => type !== null);
  }

  return null;
};
